import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	DividerComponent,
	EmptyStateComponent,
	IconComponent,
	InfoGroupComponent,
	TagComponent,
} from '@tecalisdev/infinity';
import { ExpirationDatePipe } from '../../../../../core/pipes/expiration-date.pipe';
import { transformDate } from '../../../../../core/utils/utils';
import { OPERATION_STATUS } from '../../../../../operations/models/operations.models';
import { IOperationOcrDetail } from '../../../../../processes/models/processes.models';
import { MasterService } from '../../../../services/master.service';

/**
 * Datos extraídos del OCR (equivalente al tile «Detalles» del OCR en detalle de proceso).
 * Paralelo a los bloques bajo `shared/components/operations/pol/`.
 */
@Component({
	selector: 'app-operation-ocr-details-data',
	imports: [
		TranslatePipe,
		DatePipe,
		ExpirationDatePipe,
		InfoGroupComponent,
		IconComponent,
		TagComponent,
		DividerComponent,
		EmptyStateComponent,
	],
	templateUrl: './operation-ocr-details-data.component.html',
	styleUrl: './operation-ocr-details-data.component.scss',
})
export class OperationOcrDetailsDataComponent implements OnChanges {
	@Input() data?: IOperationOcrDetail;

	public yearsOld?: number;
	public OPERATION_STATUS = OPERATION_STATUS;

	constructor(public masterService: MasterService) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['data']) {
			return;
		}
		this.yearsOld = this.computeYearsOld(this.data?.birthdate);
	}

	private computeYearsOld(birthdate?: string): number | undefined {
		if (!birthdate) {
			return undefined;
		}
		const birthDate = transformDate(birthdate);
		if (!birthDate) {
			return undefined;
		}
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	}
}
